import React from "react";
import {
	normalizeProviderKey,
	providerDisplayLabel,
	PROVIDER_ICON_SRC,
} from "./providerIcons";

export function ProviderIcon({ provider, size = 16, className = "" }) {
	const key = normalizeProviderKey(provider);
	const src = PROVIDER_ICON_SRC[key];

	if (!src) {
		return (
			<span
				className={`ai-provider-icon ai-provider-icon--fallback ${className}`.trim()}
				style={{ width: size, height: size, fontSize: size * 0.55 }}
				aria-hidden
			>
				{(providerDisplayLabel(provider) || "?").charAt(0)}
			</span>
		);
	}

	return (
		<span className={`ai-provider-icon ${className}`.trim()}>
			<img
				src={src}
				width={size}
				height={size}
				alt=""
				aria-hidden
				className="ai-provider-icon__img"
				draggable={false}
			/>
		</span>
	);
}

export function ProviderChip({
	provider,
	label,
	size = 14,
	className = "ai-provider-chip",
}) {
	return (
		<span className={className}>
			<ProviderIcon provider={provider} size={size} />
			<span>{label ?? providerDisplayLabel(provider)}</span>
		</span>
	);
}

export default ProviderIcon;
